import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "box container-narrow"
}
const _hoisted_2 = { class: "title is-5" }
const _hoisted_3 = {
  key: 1,
  class: "box container-narrow"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "title is-5" }, " Export project ", -1)
const _hoisted_5 = {
  key: 2,
  class: "box container-narrow"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "title is-5" }, " Delete project ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "block" }, " Delete all data related to this project. This operation is not revertible! ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cc_hydra_operation_form = _resolveComponent("cc-hydra-operation-form")!
  const _component_download_button = _resolveComponent("download-button")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_button = _resolveComponent("o-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.project.actions.edit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.project.actions.edit.title), 1),
          _createVNode(_component_cc_hydra_operation_form, {
            ".operation": _ctx.project.actions.edit,
            ".resource": _ctx.resource,
            ".shape": _ctx.shape,
            ".error": _ctx.error,
            ".submitting": _ctx.isSubmitting,
            onSubmit: _ctx.onSubmit,
            ".show-cancel": false,
            "submit-label": "Save project settings"
          }, null, 8, [".operation", ".resource", ".shape", ".error", ".submitting", "onSubmit"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.project.export)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_o_field, null, {
            default: _withCtx(() => [
              _createVNode(_component_download_button, {
                resource: _ctx.project.export
              }, null, 8, ["resource"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.project.actions.delete)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          (_ctx.project.actions.delete)
            ? (_openBlock(), _createBlock(_component_o_field, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_o_button, {
                    "icon-left": "trash",
                    variant: "danger",
                    onClick: _ctx.deleteProject
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.project.actions.delete.title), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}